<form class="user-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">
  <mat-form-field>
    <mat-label>{{ 'users.edit.username.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="username">
    <mat-error>{{ 'users.edit.username.errorMessage' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'users.edit.email.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="email">
    <mat-error>{{ 'users.edit.email.errorMessage' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'users.edit.role.label' | translate }}</mat-label>
    <mat-select formControlName="role">
      <mat-option *ngFor="let role of rolesList" [value]="role.id">
        {{ role.description}}
      </mat-option>
    </mat-select>
    <mat-error>{{ 'users.edit.role.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <section class="detail" formGroupName="detail">
    <mat-form-field>
      <mat-label>{{ 'users.edit.firstname.label' | translate }}</mat-label>
      <input type="text" matInput formControlName="firstname">
      <mat-error>{{ 'users.edit.firstname.errorMessage' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'users.edit.lastname.label' | translate }}</mat-label>
      <input type="text" matInput formControlName="lastname">
      <mat-error>{{ 'users.edit.lastname.errorMessage' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'users.edit.phone.label' | translate }}</mat-label>
      <input type="text" matInput formControlName="phone">
      <mat-error>{{ 'users.edit.phone.errorMessage' | translate }}</mat-error>
    </mat-form-field>
  </section>

  <ng-container *ngIf="canChooseClient">
    <fieldset class="clients-list">
      <legend>
        <h3>{{ 'users.edit.clients.title' | translate }}</h3>
      </legend>
      <mat-list formArrayName="clients">
        <mat-list-item *ngFor="let clientControl of getArray('clients').controls; index as i">
          <section class="form-field">
            <app-autocomplete [control]="clientControl" [list]="selectableClients"
              (changeEvent)="generateSelectableClients()" label="users.edit.clients.select.label"
              errorMsg="users.edit.clients.select.errorMessage">
            </app-autocomplete>
          </section>

          <button type="button" mat-icon-button color="primary" [disabled]="getArray('clients').controls.length <= 1"
            (click)="onRemoveClient(i)">
            <mat-icon aria-label="delete">delete</mat-icon>
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="canAddClient">
          <button type="button" mat-icon-button color="primary" (click)="onAddClient()">
            <mat-icon aria-label="Add">add</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </fieldset>
  </ng-container>

  <section class="sitesSection">
    <fieldset class="sites-list">
      <legend>
        <h3>{{ 'users.edit.sites.title' | translate }}</h3>
      </legend>

      <mat-checkbox class="allSites" formControlName="allSites"
        *ngIf="canChooseSite && selRole && selRole.name !== 'admin_client' && selRole.name !== 'client'"
        color="primary">
        Ajouter tous les donneurs d'ordre de
        l'agence
        <ng-container *ngIf="canChooseClient">
          choisie
          ci-dessus
        </ng-container>
      </mat-checkbox>

      <mat-list formArrayName="sites" *ngIf="sitesList && canChooseSite && !editForm.value.allSites">
        <mat-list-item *ngFor="let siteControl of getArray('sites').controls; index as i">
          <section class="form-field">
            <app-autocomplete [control]="siteControl" [list]="selectableSites" label="users.edit.sites.select.label"
              errorMsg="users.edit.sites.select.errorMessage">
            </app-autocomplete>
          </section>

          <button type="button" mat-icon-button color="primary" [disabled]="getArray('sites').controls.length <= 1"
            (click)="onRemoveSite(i)">
            <mat-icon aria-label="delete">delete</mat-icon>
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="canAddSite && !editForm.value.allSites">
          <button type="button" mat-icon-button color="primary" (click)="onAddSite()">
            <mat-icon aria-label="Add">add</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </fieldset>

    <fieldset class="featuresFieldset" *ngIf="canChooseFeatures && canHaveFeatures">
      <legend>
        <h3>Accès aux modules</h3>
      </legend>
      <p class="messageNoModules">*Si aucun module n'est coché, l'utilisateur a accès aux modules de son Agence</p>
      <label formArrayName="features" *ngFor="let feature of featuresFormArray.controls; let i = index">
        <mat-checkbox [formControlName]="i" color="primary">{{ selectablesFeatures[i]?.name }}</mat-checkbox>
      </label>
    </fieldset>


  </section>
  <!--
  <section class="allSitesSection">
    <mat-checkbox class="allSites" formControlName="allSites" *ngIf="canChooseSite">
      Ajouter tous les donneurs d'ordre de
      l'agence
      <ng-container *ngIf="canChooseClient">
        choisie
        ci-dessus
      </ng-container>
    </mat-checkbox>
  </section> -->


  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid"></app-validate-and-cancel>

</form>

<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
